export default function hasPermission(user, permission) {
  if (!permission) {
    return true;
  }

  if (!user || !Array.isArray(user.permissions)) {
    return false;
  }

  return user.permissions.includes(permission);
}

export const PERMISSIONS = {
  ONE_LINK: "one_link",
  HBBTV_VIEWERSHIP: "hbbtv_viewership",
  AVOD: "avod",
};
